const manutencao_do_ensino_anterior = {
  path: "/manutencao-do-ensino-anterior",
  redirect: "/manutencao-do-ensino-anterior",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Manutencão do Ensino Anterior",
  },
  children: [
    {
      path: "/manutencao-do-ensino-anterior",
      name: "manutencao-do-ensino-anterior",
      component: () =>
        import(
          "@/views/ManutencaoDoEnsinoAnterior/ManutencaoDoEnsinoAnteriorHome.vue"
        ),
    },
    {
      path: "/manutencao-do-ensino-anterior-novo",
      name: "manutencao-do-ensino-anterior-novo",
      component: () =>
        import(
          "@/views/ManutencaoDoEnsinoAnterior/ManutencaoDoEnsinoAnteriorCad.vue"
        ),
    },
    {
      path: "/manutencao-do-ensino-anterior/edit/:id",
      name: "manutencao-do-ensino-anterior-edit",
      component: () =>
        import(
          "@/views/ManutencaoDoEnsinoAnterior/ManutencaoDoEnsinoAnteriorEdit.vue"
        ),
    },
  ],
};

export { manutencao_do_ensino_anterior };
